import React, { useState, useEffect, useRef } from "react";

const ChatBot = () => {
  const [input, setInput] = useState("");
  const [responses, setResponses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const messagesEndRef = useRef(null);

  // Ahora apuntamos directamente a tu proxy en el servidor
  const apiUrl = "https://juancarlosmancharamos.ar/gemini_proxy.php";

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [responses, loading]);
  
  const saveToLog = async (role, text) => {
    try {
      await fetch("https://juancarlosmancharamos.ar/log_chat.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role, text })
      });
    } catch (e) {
      console.error("Error guardando log:", e);
    }
  };

  const handleSend = async () => {
    const trimmedInput = input.trim();
    if (!trimmedInput) return;

    setLoading(true);
    setResponses((prev) => [...prev, { role: "user", text: trimmedInput }]);
    
    // GUARDAR LOG DEL USUARIO
    saveToLog("user", trimmedInput);

    const promptSystem = `Actúa como el Asistente Inteligente de Juan Carlos Mancha Ramos (JCMR). 
    Tu objetivo es ayudar a los visitantes de su web personal (juancarlosmancharamos.ar) a conocer su trabajo y servicios.

    PERFIL DE JUAN CARLOS:
    - Desarrollador Full Stack Senior con más de 10 años de experiencia.
    - Especialista en: React, Next.js, Node.js, Strapi, Docker y arquitectura de APIs.
    - Experto en E-commerce: WooCommerce y PrestaShop.
    - Cofundador de Disegno Web Bologna (Italia).

    REGLAS DE CONTACTO (CRÍTICO):
    1. Si preguntan por contacto/presupuesto:
       - WhatsApp: +54 351 2768802.
       - Email: info@disegnowebologna.ar.
    2. Menciona que trabaja para clientes de todo el mundo desde Córdoba, Argentina.
    
    CONSULTA DEL USUARIO: ${trimmedInput}`;

    try {
      // Llamada al PROXY PHP
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          contents: [{ parts: [{ text: promptSystem }] }]
        })
      });

      const data = await response.json();
      
      if (data && data.candidates && data.candidates[0] && data.candidates[0].content) {
        const botText = data.candidates[0].content.parts[0].text;
        setResponses((prev) => [...prev, { role: "bot", text: botText }]);
        
        // GUARDAR LOG DEL BOT
        saveToLog("bot", botText);
      }
    } catch (error) {
      console.error("Chat error via Proxy:", error);
    } finally {
      setLoading(false);
      setInput("");
    }
  };

  return (
    <div style={styles.container}>
      <button 
        onClick={() => setIsOpen(!isOpen)} 
        style={{...styles.fab, transform: isOpen ? "rotate(90deg)" : "rotate(0deg)"}}
      >
        {isOpen ? "✕" : "💬"}
      </button>

      {isOpen && (
        <div style={styles.window}>
          <div style={styles.header}>
            <div style={styles.onlineStatus}></div>
            <span style={{fontWeight: "600"}}>Asistente Virtual JCMR</span>
          </div>

          <div style={styles.chatArea}>
            {responses.length === 0 && (
              <div style={styles.welcome}>¡Hola! ¿En qué puedo ayudarte hoy?</div>
            )}
            {responses.map((msg, i) => (
              <div key={i} style={{ 
                ...styles.messageWrapper, 
                justifyContent: msg.role === "user" ? "flex-end" : "flex-start" 
              }}>
                <div style={{ 
                  ...styles.bubble, 
                  background: msg.role === "user" ? "#ffaf00" : "#ffffff",
                  color: msg.role === "user" ? "#fff" : "#333",
                  boxShadow: msg.role === "user" ? "none" : "0 2px 5px rgba(0,0,0,0.05)"
                }}>
                  {msg.text}
                </div>
              </div>
            ))}
            {loading && <div style={styles.typing}>Juan Carlos está pensando...</div>}
            <div ref={messagesEndRef} />
          </div>

          <div style={styles.inputArea}>
            <input 
              value={input} 
              onChange={(e) => setInput(e.target.value)} 
              onKeyDown={(e) => { if (e.key === "Enter") handleSend(); }}
              placeholder="Escribe un mensaje..." 
              style={styles.input}
            />
            <button onClick={handleSend} style={styles.sendBtn}>➤</button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { 
    position: "fixed", 
    bottom: "20px", 
    right: "20px", 
    zIndex: 9999 
  },
  fab: { 
    width: "60px", 
    height: "60px", 
    borderRadius: "30px", 
    background: "#ffaf00", 
    color: "white", 
    fontSize: "24px", 
    border: "none", 
    boxShadow: "0 4px 15px rgba(255, 175, 0, 0.4)", 
    cursor: "pointer", 
    transition: "all 0.3s ease", 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center" 
  },
  window: { 
    position: "absolute", 
    bottom: "70px", 
    right: "0", 
    // USAMOS MEDIA QUERIES O LÓGICA DE ANCHO FLEXIBLE
    width: window.innerWidth < 480 ? "calc(100vw - 40px)" : "350px", 
    height: window.innerWidth < 480 ? "70vh" : "500px", 
    maxHeight: "600px",
    background: "rgba(255, 255, 255, 0.98)", 
    borderRadius: "20px", 
    display: "flex", 
    flexDirection: "column", 
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)", 
    overflow: "hidden" 
  },
  header: { 
    background: "#ffaf00", 
    color: "white", 
    padding: "15px 20px", 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "space-between" // Para separar el título del estado
  },
  chatArea: { 
    flex: 1, 
    overflowY: "auto", 
    padding: "15px", 
    display: "flex", 
    flexDirection: "column", 
    gap: "10px", 
    background: "#f8f9fa",
    fontSize: window.innerWidth < 480 ? "16px" : "14px" // Texto un poco más grande en móvil para leer mejor
  },
  bubble: { 
    padding: "10px 14px", 
    borderRadius: "15px", 
    fontSize: "inherit", // Hereda del chatArea
    maxWidth: "85%",
    wordWrap: "break-word" // Evita que textos largos rompan el diseño
  },
  inputArea: { 
    padding: "12px", 
    background: "#fff", 
    display: "flex", 
    gap: "8px", 
    borderTop: "1px solid #eee" 
  },
  input: { 
    flex: 1, 
    border: "1px solid #ddd", 
    borderRadius: "20px", 
    padding: "8px 15px", 
    outline: "none", 
    fontSize: "16px" // Evita el zoom automático de iPhone al enfocar inputs
  }
};

export default ChatBot;